const isValidDate = (date) => date && date !== 'Present';

export default isValidDate;
